import React from 'react';
import { prepareData } from 'utils/googleData';

export function ProductOverview(props) {
    const { title, enable, items } = prepareData({ props });
    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>;
    }

    return (
        <div className="bg-white dark:bg-red py-8">
            <div className="container mx-auto px-4">
                <h2 className="text-3xl font-semibold text-center text-gray-800 dark:text-dark mb-10">{title}</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {items?.length > 0 && items.map((product, index) => (
                        <div key={index} className="p-6 bg-white dark:bg-gray-700 shadow-lg rounded-lg hover:shadow-xl transition-shadow duration-300">
                            <h3 className="text-xl font-semibold text-blue-600 dark:text-dark/50 mb-2">{product.name}</h3>
                            <p className="text-gray-700 dark:text-dark/90 text-sm mb-3">{product.description}</p>
                            <ul className="list-disc list-inside text-gray-600 dark:text-dark/80 text-sm">
                                {product.features.map((feature, fIndex) => (
                                    <li key={fIndex}>{feature.name}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ProductOverview;
